/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface AssignmentReferencesCountsDto
 */
export interface AssignmentReferencesCountsDto {

    /**
     * Live events of the assignment: pending + performed + unattended
     *
     * @type {number}
     * @memberof AssignmentReferencesCountsDto
     * @example 12
     */
    total: number;

    /**
     * Not yet started (SCHEDULED, DELAYED) — cancelled outright
     *
     * @type {number}
     * @memberof AssignmentReferencesCountsDto
     * @example 8
     */
    pending: number;

    /**
     * Attempted by the member (IN_PROGRESS, COMPLETED, NOT_COMPLETED). The only events that recorded training data.
     *
     * @type {number}
     * @memberof AssignmentReferencesCountsDto
     * @example 3
     */
    performed: number;

    /**
     * Planned and never attempted (MISSED, SKIPPED)
     *
     * @type {number}
     * @memberof AssignmentReferencesCountsDto
     * @example 1
     */
    unattended: number;

    /**
     * Being performed right now. Above zero the delete is refused outright: a station is mid-session on this therapy.
     *
     * @type {number}
     * @memberof AssignmentReferencesCountsDto
     * @example 0
     */
    running: number;
}
